import { useTranslations } from 'next-intl'
import { useForm } from 'react-hook-form'

import { PhoneField } from '@/features/update-user-information'
import {
  PhoneVerificationButton,
  type PhoneVerificationResult,
  type TPhoneVerificationForm,
} from '@/features/verify-identity'
import { Form } from '@/shared/ui'

type Props = {
  isVerified?: boolean
  disabled?: boolean
  onSuccess: (result: PhoneVerificationResult) => void
  className?: string
}

export const PhoneVerification = ({
  isVerified = false,
  disabled = false,
  onSuccess,
  className,
}: Props) => {
  const t = useTranslations('verification')

  const form = useForm<TPhoneVerificationForm>()

  const handleVerificationSuccess = (result: PhoneVerificationResult) => {
    form.setValue('phoneNumber', result.phoneNumber)
    onSuccess(result)
  }

  return (
    <Form.Root form={form} className={className}>
      <div className="flex flex-col gap-2">
        {isVerified && <PhoneField label={t('phone_number_label')} />}
        <PhoneVerificationButton
          disabled={disabled}
          onSuccess={handleVerificationSuccess}
        >
          {isVerified
            ? t('button.verify_phone_completed')
            : t('button.verify_phone')}
        </PhoneVerificationButton>
      </div>
    </Form.Root>
  )
}
